import { inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';

import { CustomWindowResilContrats } from '@features/termination/interfaces';

import { WebviewService } from './webview.service';

@Injectable({
  providedIn: 'root',
})
export class IosWebviewService extends WebviewService {
  private readonly windowRef = inject<CustomWindowResilContrats>(WA_WINDOW);

  public closeWebView(): void {
    this.windowRef.webkit.messageHandlers.closeWebView.postMessage({});
  }

  public openContact(): void {
    this.windowRef.webkit.messageHandlers.openContact.postMessage({});
  }
}
